<template>
  <button class="feed_type_btn" :class="{ active: isActive }">
    <img :src="img" />
    {{ text }}
  </button>
</template>

<script>
export default {
  name: "FeedTypeBtn",
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
.feed_type_btn {
  padding: 13px 24px 13px 13px;
  border: none;
  border-radius: 15px;
  background-color: transparent;
  color: rgba(125, 125, 125, 1);
  transition: all var(--transition-time) ease;
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 14px;
}

.feed_type_btn img {
  opacity: 0.5;
}

.feed_type_btn:hover {
  background: var(--hover);
  color: var(--text-color);
}

.feed_type_btn.active,
.feed_type_btn.active {
  background: var(--nav-bg);
  color: var(--text-color);
}

.feed_type_btn.active img {
  opacity: 1;
}
</style>
